

import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  login,
  signFailed,
  loginNumber,
  twoFactorAuthentication,
  logout,
} from "../../redux/actions/auth";
import ModalComponent from "../../components/Modal";
import { Link, useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";
// import SelectLabels from "../../components/SelectLabels";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import authReducer from "../../redux/reducers";
import { toast, ToastContainer } from "react-toastify";
import LoginLoader from "../../components/LoginLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
// import { FormControlLabel, Checkbox, FormGroup } from '@material-ui/core';
import {
  IconButton,
  InputAdornment,
  ThemeProvider,
  createTheme,
  Backdrop,
  Button,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { xCheckSumIdGernator } from "../../helper/helper";
import Loader from "../../components/Loader";
import Avatar from "@mui/material/Avatar";
// import fireLogo from "../../assets/images/firebird.png";
// import fireLogo from "../../assets/images/moov_logo.png"
import fireLogo from "../../assets/images/logoMoov.jpg";

import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import KeyIcon from "@mui/icons-material/Key";
import { Numbers } from "@mui/icons-material";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import { useSelector } from "react-redux";
import moment from "moment";
import sha512 from "crypto-js/sha512";
import { xCheckSumIdGernator1 } from "../../helper/PinHelper";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DoneIcon from "@mui/icons-material/Done";
import { TwofactAuth } from "../../redux/features/pageSlices";
import OtpTimer from "otp-timer";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import ShieldIcon from "@mui/icons-material/Shield";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckIcon from "@mui/icons-material/Check";
const customId1 = "custom-id-yess";
function LoginInTheHouse(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [isOpenOtp, setIsOpenOtp] = useState(false);
  const [value, setValue] = React.useState(0);
  const [verified, setVerified] = useState(false);
  const [otpVerify, setOtpVerify] = useState(
    localStorage.getItem("transactionId")
  );
  const [googleAuth, setgoogleAuth] = useState(
    localStorage.getItem("googleAuth")
  );

  const [otpOnchange, setOtpOnChange] = useState();
  const [contactus, setContactus] = useState({
    name: "",
    email: "",
    msisdn: "",
    subject: "",
    message: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  //   const [hideshow, setHideShow] = useState({
  //     password:'',
  //     o
  //   });
  const [type, setType] = useState(true);
  // console.log("kougy", otpVerify);
  const [signType, setSignType] = useState(true);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const Datee = useSelector((state) => state?.dashboardReducer?.timeSeries);
  const array = useSelector((state) => state?.usersReducer);

  // console.log({ array });

  const tempuser = localStorage.getItem("otpstatus");
  const tempuserr = localStorage.getItem("emailverification");
  const statusCodee = localStorage.getItem("statuscode");

  const rester = () => {
    if (statusCodee == 201) {
      history.push("/AccountVerification");
    } else {
      history.push("/");
    }
  };

  useEffect(() => {
    rester();
  }, [statusCodee]);

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const dispatch = useDispatch();

  const recaptchaReloaded = (value) => {
    if (value == "") {
      setVerified(false);
    } else {
      setVerified(true);
    }
  };
  const signuppp = () => {
    setSignType(false);
  };
  const signupppnot = () => {
    setSignType(true);
  };

  const phoneNumber = () => {
    setType(true);
  };

  const email = () => {
    setType(false);
  };
  const resetSTATE = () => {
    dispatch(signFailed());
  };

  const arr = ["a", "b", "c", "d", "e"];
  // const newArr = arr.slice(1, 3);
  const newArr = arr.slice(3, 1);

  // console.log(newArr, "helllo");

  const validationSchema = yup.object({
    username: yup
      .string("Enter Your Username")
      .required("Field is required")
      .min(3, "Username should be at least 3 characters long")
      .matches(/^(\S+$)/g, "This field cannot contain blankspaces")
      .when("type", () => {
        // console.log({ type }, isNaN(type));
        if (!isNaN(type)) {
          return yup
            .string()
            .required("Phone Number is required")
            .min(11, "Phone Number should be of minimum 11 characters length")
            .max(11, "Phone Number should be of minimum 11 characters length")
            .matches(/^(\S+$)/g, "This field cannot contain  blankspaces");
        }
      }),
    password: yup
      .string("Enter your password")
      .min(2, "Password should be of minimum 2 characters length")
      .required("Password is required")
      .when("type", () => {
        // console.log({ type }, isNaN(type));
        if (!isNaN(type)) {
          return yup.string();
        }
      }),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        // console.log(values.password);
        // console.log(values.password);
        // console.log(value);
        if (type) {
          return props.login(String(values.username), values.password, value);
        }

        props.login(Number(values.username), values.password, value);
      } catch (error) {
        // console.log(error);

        // await toast.error("Something Went Wrong", {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  const formik1 = useFormik({
    initialValues: {
      otp: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validationSchema: yup.object({
      otp: yup
        .string()
        .required("OTP is required")
        .min(4, "OTP should be minimum  4 characters long")
        .max(4, "OTP should be maximum  4 characters long")
        .matches(/^(\S+$)/g, "This field cannot contain blankspaces"),
    }),

    onSubmit: async (values) => {
      try {
        return props.loginNumber(values.otp);
      } catch (error) {
        // console.log(error);

        // await toast.error("Something Went Wrong", {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  const sendOtp = async () => {
    try {
      setOpen(true);
      const xCheckSumValues = xCheckSumIdGernator(formik.values.username);
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/pin/generate`,

        {
          // msisdn: Number(parseData.mobile),
          msisdn: Number(formik.values.username),
          requestId: xCheckSumValues.generator,
          isDebug: false,
        },
        {
          headers: {
            "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
          },
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        localStorage.setItem("transactionId", res.data.transactionId);
        localStorage.setItem("msisdn", res.data.msisdn);
        // await toast.success("Otp Sent Successfully", {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Otp Sent Successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setIsOpenOtp(true);
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);

      // await toast.error("Something Went Wrong", {
      //   theme: "colored",
      //   customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      setOpen(false);
    }
  };

  const modalContact = useRef(null);
  const modalContactClose = useRef(null);

  const contactModal = async () => {
    await modalContact.current.click();
  };

  const contactUs = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      const generator = Math.floor(Math.random() * 100000000);
      const allValues = `${contactus.msisdn}${generator}54IzSRi`;
      const allValuesHashed = sha512(allValues).toString();
      // console.log({ allValues, generator });
      // console.log({ allValuesHashed });

      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/admin/v1/lead/generation/add`,
        {
          name: contactus.name,
          email: contactus.email,
          msisdn: "222" + contactus.msisdn,
          subject: contactus.subject,
          message: contactus.message,
          requestId: generator,
          isDebug: true,
        },
        {
          headers: {
            "X-CHECKSUM-ID": allValuesHashed,
          },
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        await modalContactClose?.current?.click();
        await setTimeout(() => {
          // toast.success("Your query has been Submitted !!", {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Your query has been Submitted !!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      } else {
        setOpen(false);
        await modalContactClose?.current?.click();
        await setTimeout(() => {
          // toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    } catch (error) {
      setOpen(false);
      await modalContactClose?.current?.click();
      // console.log(error);

      // await toast.error("Something Went Wrong ! Please check your network", {
      //   theme: "colored",
      //   customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong ! Please check your network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // .............................. Mobile Number generator..............................................................//

  const MobileNumberGenerator = async (e) => {
    e?.preventDefault();
    setOpen(true);
    try {
      if (selectedValue === "Mobile Number") {
        // const xCheckSumValues = xCheckSumIdGernator1(JSON.parse(localStorage.getItem("items"))?.mobile);
        // console.log("x--",xCheckSumValues)

        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/two-factor/v1/pin-generate`,

          {
            // msisdn: Number(parseData.mobile),
            msisdn: JSON.parse(localStorage.getItem("items"))?.mobile,
            // requestId: xCheckSumValues.generator,
            authType: "mobile",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              UserId: `${localStorage.getItem("UserId")}`,
              Source: "web",
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setOtpVerify(res.data.transactionId);
          localStorage.setItem("transactionId", res.data.transactionId);
          // await toast.success("Otp Sent Successfully", {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Otp Sent Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (selectedValue === "Email") {
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/two-factor/v1/pin-generate`,

          {
            // msisdn: Number(parseData.mobile),
            email: JSON.parse(localStorage.getItem("items"))?.email,
            authType: "email",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              UserId: `${localStorage.getItem("UserId")}`,
              Source: "web",
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setOtpVerify(res.data.transactionId);
          localStorage.setItem("transactionId", res.data.transactionId);

          // await toast.success("Otp Sent Successfully", {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Otp Sent Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (selectedValue === "Google Authneticator") {
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/two-factor/v1/pin-generate`,

          {
            // msisdn: Number(parseData.mobile),
            // email: JSON.parse(localStorage.getItem("items"))?.email,
            authType: "Google Authenticator",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              UserId: `${localStorage.getItem("UserId")}`,
              Source: "web",
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          // setOtpVerify(res.data.transactionId);
          setgoogleAuth(res.data.googleAuthUrl); 
          localStorage.setItem("googleAuth", res.data.googleAuthUrl);
          // localStorage.setItem("transactionId", res.data.transactionId);

          // await toast.success("Otp Sent Successfully", {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Otp Sent Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      // console.log(error);

      // await toast.error("Something Went Wrong", {
      //   theme: "colored",
      //   customId1,
      // });
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // ..........................................................................................................................//
  // .............................. Mobile Number generator..............................................................//

  const VerifyOtp = async (e) => {
    e.preventDefault();
    setOpen(true);
    try {
      if (selectedValue === "Mobile Number") {
        // const xCheckSumValues = xCheckSumIdGernator1(JSON.parse(localStorage.getItem("items"))?.mobile);
        // console.log("x--",xCheckSumValues)

        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/two-factor/v1/pin-verify`,

          {
            // msisdn: Number(parseData.mobile),
            msisdn: JSON.parse(localStorage.getItem("items"))?.mobile,
            transactionId: otpVerify,
            authType: "mobile",
            // otp:otpOnchange
            otp: part1 + part2 + part3 + part4 + part5 + part6,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              UserId: `${localStorage.getItem("UserId")}`,
              Source: "web",
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          await localStorage.setItem("is2FactorAuth", "0");
          dispatch(TwofactAuth("0"));
          setOtpVerify();
          localStorage.removeItem("transactionId");

          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          // await toast.success("Otp Sent Successfully", {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Verified Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else if (res.data.statusDescription.statusCode == 206) {
          setOpen(false);
          setOtpVerify();

          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          setOtpVerify();
          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
       else if (selectedValue === "Email") {
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/two-factor/v1/pin-verify`,

          {
            transactionId: otpVerify,
            email: JSON.parse(localStorage.getItem("items"))?.email,
            authType: "email",
            // otp:otpOnchange
            otp: part1 + part2 + part3 + part4 + part5 + part6,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              UserId: `${localStorage.getItem("UserId")}`,
              Source: "web",
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          await localStorage.setItem("is2FactorAuth", "0");
          dispatch(TwofactAuth("0"));
          setOtpVerify();
          localStorage.removeItem("transactionId");
          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          // await toast.success("Otp Sent Successfully", {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Verified Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else if (res.data.statusDescription.statusCode == 206) {
          setOpen(false);
          setOtpVerify();

          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          setOtpVerify();
          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }

      else if (selectedValue === "Google Authneticator") {
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/two-factor/v1/pin-verify`,

          {
            // transactionId: otpVerify,
            // email: JSON.parse(localStorage.getItem("items"))?.email,
            authType: "Google Authenticator",
            // otp:otpOnchange
            googleAUthOtp: part1 + part2 + part3 + part4 + part5 + part6,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              UserId: `${localStorage.getItem("UserId")}`,
              Source: "web",
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          await localStorage.setItem("is2FactorAuth", "0");
          dispatch(TwofactAuth("0"));
          // setOtpVerify();
          setgoogleAuth();
          localStorage.removeItem("googleAuth");
          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          // await toast.success("Otp Sent Successfully", {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Verified Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else if (res.data.statusDescription.statusCode == 206) {
          setOpen(false);
          setOtpVerify();

          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          setOtpVerify();
          setPart1("");
          setPart2("");
          setPart3("");
          setPart4("");
          setPart5("");
          setPart6("");
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      setOtpVerify();

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // ..........................................................................................................................//
  // ...................................Two Factor Auth.............................................................//

  const [selectedValue, setSelectedValue] = useState("");

  const handleChange2fa = (event) => {
    setSelectedValue(event.target.value);
  };
  const Twowayauth = useSelector((state) => state.pageReducer.TwofactAuth);
  // console.log("se--", selectedValue)
  // const Useremail = JSON.parse(localStorage?.getItem("items"))?.email
  // const maskedEmail = '*'.repeat(email.length - 4) + email.slice(-"4");
  const backButton = async () => {
    localStorage.setItem("is2FactorAuth", "0");
    await props.logout();
    dispatch(TwofactAuth("0"));

    return props.twoFactorAuthentication();
  };

  // ...............................................
  const firstFourChars = JSON.parse(localStorage.getItem("items"))?.email.slice(
    0,
    4
  );
  const lastTenChars = JSON.parse(localStorage.getItem("items"))?.email.slice(
    -10
  );
  const maskedEmail =
    firstFourChars +
    JSON.parse(localStorage.getItem("items"))
      ?.email.slice(4, -10)
      .replace(/./g, "X") +
    lastTenChars;

  // ........................................................ IP ..................................................................//

  const [part1, setPart1] = useState("");
  const [part2, setPart2] = useState("");
  const [part3, setPart3] = useState("");
  const [part4, setPart4] = useState("");
  const [part5, setPart5] = useState("");
  const [part6, setPart6] = useState("");
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);  
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  // console.log("oip", Ip);
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value >= 0 && value <= 9) {
      setPart1(value);
    }
  };
  const handleInputChange2 = (event) => {
    const value = event.target.value;
    if (value >= 0 && value <= 9) {
      setPart2(value);
    }
  };
  const handleInputChange3 = (event) => {
    const value = event.target.value;
    if (value >= 0 && value <= 9) {
      setPart3(value);
    }
  };
  const handleInputChange4 = (event) => {
    const value = event.target.value;
    if (value >= 0 && value <= 9) {
      setPart4(value);
    }
  };
  const handleInputChange5 = (event) => {
    const value = event.target.value;
    if (value >= 0 && value <= 9) {
      setPart5(value);
    }
  };

  const handleInputChange6 = (event) => {
    const value = event.target.value;
    if (value >= 0 && value <= 9) {
      setPart6(value);
    }
  };

  useEffect(() => {
    if (part1.length == 1) {
      inputRef2.current.focus();
    }
  }, [part1]);

  useEffect(() => {
    if (part2.length == 1) {
      inputRef3.current.focus();
    }
  }, [part2]);

  useEffect(() => {
    if (part3.length == 1) {
      inputRef4.current.focus();
    }
  }, [part3]);
  useEffect(() => {
    if (part4.length == 1) {
      inputRef5.current.focus();
    }
  }, [part4]);
  useEffect(() => {
    if (part5.length == 1) {
      inputRef6.current.focus();
    }
  }, [part5]);
  useEffect(() => {
    if (part6.length == 1) {
      inputRef6.current.focus();
    }
  }, [part6]);

  const handleKeyDown1 = (event) => {
    // console.log("mkk", event.key);
    if (event.key === "Backspace") {
      event.preventDefault();
      setPart6("");
      inputRef5.current.focus();
    }
  };
  const handleKeyDown2 = (event) => {
    // console.log("mkk", event.key);
    if (event.key === "Backspace") {
      event.preventDefault();
      setPart2("");
      inputRef1.current.focus();
    }
  };
  const handleKeyDown3 = (event) => {
    // console.log("mkk", event.key);
    if (event.key === "Backspace") {
      event.preventDefault();
      setPart3("");
      inputRef2.current.focus();
    }
  };
  const handleKeyDown4 = (event) => {
    // console.log("mkk", event.key);
    if (event.key === "Backspace") {
      event.preventDefault();
      setPart4("");
      inputRef3.current.focus();
    }
  };
  const handleKeyDown5 = (event) => {
    // console.log("mkk", event.key);
    if (event.key === "Backspace") {
      event.preventDefault();
      setPart5("");
      inputRef4.current.focus();
    }
  };

  const handleKeyDown6 = (event) => {
    // console.log("mkk", event.key);
    if (event.key === "Backspace") {
      event.preventDefault();
      setPart6("");
      inputRef5.current.focus();
    }
  };
// ......................................................Scanner Modal.........................................................//
const [scanQrDetail, setScanQrDetail] = useState(undefined);

const modelScan2 = useRef(null);

const ScanUserModal = async (cell) => {
  // console.log(cell.row.original);
  // alert("gg")
  await modelScan2.current.click();

  await setScanQrDetail(cell.row.original);
};
// ............................................................................................................................//
  return (
    <>
      <body class="g-sidenav-show login_8 bg-gray-200 bg_gradient">
        <ToastContainer autoClose={5000} />
        <ThemeProvider theme={theme}>
          <Backdrop
            sx={{
              transform: "translateZ(0)",
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>

          <button
            ref={modalContact}
            type="button"
            class="btn btn-primary"
            data-bs-toggle="modal"
            className="btn btn-primary d-none"
            data-bs-target="#exampleModal"
            // data-bs-whatever="@mdo"
          >
            Open modal for contact
          </button>

          <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <form onSubmit={contactUs}>
                  <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">
                      Contact Us
                    </h1>
                    <button
                      type="reset"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      ref={modalContactClose}
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div className="row">
                      <div class="col-md-6">
                        <label for="recipient-name" class="col-form-label">
                          Name:
                        </label>
                        <input
                          min={3}
                          required
                          type="text"
                          class="form-control form_Control"
                          id="recipient-name"
                          onChange={(e) => {
                            setContactus({
                              ...contactus,
                              name: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div class="col-md-6 ">
                        <label for="recipient-name" class="col-form-label">
                          E-mail:
                        </label>
                        <input
                          required
                          type="email"
                          class="form-control form_Control"
                          id="email-name"
                          onChange={(e) => {
                            setContactus({
                              ...contactus,
                              email: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="row my-3">
                      <div class=" col-md-6 mb-2">
                        <label for="recipient-name" class="col-form-label">
                          Phone-Number:
                        </label>
                        <div className="d-flex">
                          <div className="w-25">
                            <input
                              className="inpt_Width w-100"
                              disabled
                              value="+222"
                            />
                          </div>
                          <input
                            required
                            type="number"
                            maxLength={8}
                            class="form-control form_Control form_Control_radius w-100"
                            id="phone-number-name"
                            onChange={(e) => {
                              setContactus({
                                ...contactus,
                                msisdn: e.target.value,
                              });
                            }}
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 8);
                            }}
                          />
                        </div>
                      </div>
                      <div class=" col-md-6 mb-2">
                        <label for="recipient-name" class="col-form-label">
                          Subject:
                        </label>
                        <input
                          required
                          type="text"
                          class="form-control form_Control"
                          id="subject-name"
                          onChange={(e) => {
                            setContactus({
                              ...contactus,
                              subject: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div class="mb-2">
                      <label for="message-text" class="col-form-label">
                        Message:
                      </label>
                      <textarea
                        required
                        rows={6}
                        class="form-control form_Control"
                        id="message-text"
                        onChange={(e) => {
                          setContactus({
                            ...contactus,
                            message: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-between align-items-center">
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                      // onClick={() => {
                      //   form.reset
                      // }}
                    >
                      Close
                    </button>
                    <button type="submit" class="btn btn-primary">
                      Send message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>


          <div>
                                    <button
                                      ref={modelScan2}
                                      type="button"
                                      className="btn btn-primary d-none"
                                      data-bs-toggle="modal"
                                      data-bs-target="#staticBackdrop"
                                    >
                                      Launch static backdrop modal
                                    </button>

                                    <div
                                      className="modal fade"
                                      id="staticBackdrop"
                                      data-bs-backdrop="static"
                                      data-bs-keyboard="false"
                                      tabindex="-1"
                                      aria-labelledby="staticBackdropLabel"
                                      aria-hidden="true"
                                    >
                                      <div className="modal-dialog">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5
                                              className="modal-title"
                                              id="staticBackdropLabel"
                                            >
                                            Scan QR Code
                                            </h5>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                              onClick={()=>{
                                                setPart1("");
                                      setPart2("");
                                      setPart3("");
                                      setPart4("");
                                      setPart5("");
                                      setPart6("");
                                              }}
                                            ></button>
                                          </div>
                                          <div className="modal-body">
                                          <div>
                          <img src={googleAuth} alt="Loading.." />
                        </div>
                        <div class="col-md-12 my-auto">
                          <form class="form_hire p-0" onSubmit={VerifyOtp}>
                            <div class="" id="sign_in">
                              {/* <div class="">
                                <div class="d-flex text-center">
                              
                                  <div class="mx-auto position-relative">
                                    <ShieldIcon
                                      style={{
                                        fontSize: "2.6rem",
                                        color: "rgb(0, 131, 173)",
                                      }}
                                    />
                                    <div
                                      className="d-flex position-absolute"
                                      style={{
                                        top: "0",
                                        bottom: "0",
                                        left: "0",
                                        right: "0",
                                      }}
                                    >
                                      <CheckIcon
                                        className="m-auto text-white"
                                        style={{ fontSize: "1.9rem" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="text-center mt-4">
                                  <span class="" style={{ fontWeight: "500" }}>
                                    Verification Code
                                  </span>
                                  <p class="my-4">
                                    <span style={{ fontWeight: "500" }}>
                                      Welcome,
                                    </span>{" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {localStorage.getItem("Username")}
                                    </span>
                                  </p>
                                
                                </div>
                              </div> */}

                              <div class="my-4">
                                <div
                                  class="input-group input-group-outline input_field mx-auto"
                                  style={{ width: "60%", background: "none" }}
                                >
                                  {/* <TextField
                                required
                                className="w-20"
                                label="Verify Otp"
                                name="otp"
                                // type="email"
                                variant="standard"
                                size="small"
                                autoFocus
                                value={otpOnchange}
                                  onChange={(event) => {
                                    setOtpOnChange(event.target.value);
                                  }}
                              /> */}
                                  <div className="row alignDivnew">
                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part1"
                                        className="impMargin1 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        ref={inputRef1}
                                        value={part1}
                                        onChange={(event) =>
                                          handleInputChange(event, setPart1)
                                        }
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart1("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part2"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part2}
                                        ref={inputRef2}
                                        onChange={(event) =>
                                          handleInputChange2(event, setPart2)
                                        }
                                        onKeyDown={handleKeyDown2}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart2("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part3"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part3}
                                        ref={inputRef3}
                                        onChange={(event) =>
                                          handleInputChange3(event, setPart3)
                                        }
                                        onKeyDown={handleKeyDown3}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart3("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part4"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part4}
                                        ref={inputRef4}
                                        onChange={(event) =>
                                          handleInputChange4(event, setPart4)
                                        }
                                        onKeyDown={handleKeyDown4}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart4("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part4"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part5}
                                        ref={inputRef5}
                                        onChange={(event) =>
                                          handleInputChange5(event, setPart5)
                                        }
                                        onKeyDown={handleKeyDown5}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart5("");
                                          }
                                        }}
                                      />
                                    </div>
                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part4"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part6}
                                        ref={inputRef6}
                                        onChange={(event) =>
                                          handleInputChange6(event, setPart6)
                                        }
                                        onKeyDown={handleKeyDown6}
                                      />
                                    </div>
                                  
                                  </div>
                                </div>
                                <div className="counterDiv">
                                
                                  <OtpTimer
                                    id="btn_reset"
                                    className="mt-2"
                                    minutes={4}
                                    seconds={59}
                                    text=" "
                                    ButtonText="Resend Otp"
                                    resend={MobileNumberGenerator}
                                  />
                                 
                                </div>
                                
                                <div className="col-md-8 mx-auto mt-5 d-flex justify-content-between">
                                  {/* <button
                                    type="button"
                                    className="btn bg-gradient-secondary m-0 w_btn btn_w8 btnReset btn_design1"
                                    onClick={() => {
                                      setOtpVerify();
                                      localStorage.removeItem("transactionId");
                                      localStorage.removeItem("googleAuth");
                                      setgoogleAuth();
                                      setPart1("");
                                      setPart2("");
                                      setPart3("");
                                      setPart4("");
                                      setPart5("");
                                      setPart6("");
                                    }}
                                  >
                                    Back
                                  
                                  </button> */}
                                  <button
                                    disabled={
                                      part1 === "" ||
                                      part2 === "" ||
                                      part3 === "" ||
                                      part4 === ""
                                    }
                                    type="submit"
                                    className="btn w_btn m-0 btn_w8 btn_design2"
                                    style={{
                                      backgroundImage:
                                        " linear-gradient(195deg,#004872,#008cb6)",
                                      fontSize: "14px",
                                    }}
                                    // onClick={VerifyOtp}
                                  >
                                    Confirm Otp
                                    {/* <SettingsBackupRestoreRoundedIcon
                          style={{ fontSize: "17px" }}
                        />{" "} */}
                                  </button>
                                </div>
                                <div></div>
                              </div>
                            </div>
                          </form>
                        </div>
                                          </div>
                                          {/* <div className="modal-footer justify-content-between">
                                           
                                            <button
                                              type="button"
                                              className="btn btn-secondary w_bt"
                                              data-bs-dismiss="modal"
                                            >
                                              Cancel
                                            </button>
                                          
                                          </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>


          <main class="main-content my-aut lgin_cntnt position-relative w-auto  border-radius-l  ">
            {Twowayauth == null || Twowayauth == 0 || Twowayauth == undefined
            
             ? (
              <>
                <div class="container-fluid px-0">
                  <div class="row d-md-flex d-none h_vh align-items-cente mx-0">
                    <div class="col-md-7 bg_18 d-flex">
                      <div class="ps_8 my-auto py_5">
                        <img src={fireLogo} class="img-fluid d-block mx-auto" />
                        {/* <img src={fireLogo} class="img-fluid d-block mx-auto" /> */}

                        <p class="text-center m-0 my-4 fw-bold">
                          Moov Mauritel, An Omni Channel Solution which broadens
                          Communication channels to Telecom operators. Its an
                          integrated platform to meet the Business requirements
                          with respect to Messaging solutions and Voice
                          solutions.
                        </p>
                        <div
                          class="d-flex justify-content-center align-items-center fw-bold"
                          style={{ color: "#000" }}
                        >
                          {/* <Link to="/contactus"> */}
                          <Button
                            variant="contained"
                            endIcon={<ContactEmergencyIcon />}
                            onClick={() => {
                              contactModal();
                            }}
                          >
                            Contact US
                          </Button>
                          {/* </Link> */}
                          {/* <ConnectWithoutContactIcon
                          style={{ cursor: "pointer", fontSize: "28px" }}
                          className="d-block ms-3"
                        /> */}
                        </div>
                      </div>
                      {/* <div className="text-center">
                    <ConnectWithoutContactIcon />
                  </div> */}
                    </div>
                    <div
                      class="col-md-5 d-flex align-items-center bg_8 "
                      style={{ padding: "3.5rem" }}
                    >
                      <div class="w-100">
                        {!isOpenOtp && (
                          <form
                            class="form_hire p-0"
                            onSubmit={formik.handleSubmit}
                          >
                            <div class="" id="sign_in">
                              <div class="">
                                <div class="text-center">
                                  <LockOpenIcon
                                    style={{
                                      fontSize: "25px",

                                      color: "white",
                                      border: "0.5px solid #0083AD",
                                      borderRadius: "30px",
                                      backgroundColor: "#0083AD",
                                    }}
                                  />
                                </div>
                                <div class="text-center mt-2">
                                  <span class="d-inline-block text-capitalize">
                                    sign in
                                  </span>
                                </div>
                              </div>

                              <div class="my-4">
                                <div class="input-group input-group-outline input_field">
                                  {isNaN(formik.values.username) == true ? (
                                    <>
                                      <div class="col-md-12 d-inline-flex">
                                        <div className="me-2 mt-3">
                                          <PersonIcon />
                                        </div>
                                        <TextField
                                          required
                                          className="w-100"
                                          label="Username/Mobile Number"
                                          name="username"
                                          // type="email"
                                          variant="standard"
                                          size="small"
                                          value={formik.values.username}
                                          onChange={(e) => {
                                            setType(e.target.value);
                                            formik.handleChange(e);
                                          }}
                                          error={
                                            formik.touched.username &&
                                            Boolean(formik.errors.username)
                                          }
                                          helperText={
                                            formik.touched.username &&
                                            formik.errors.username
                                          }
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div class="col-md-12 d-inline-flex">
                                        <div className="me-2 mt-3">
                                          <PersonIcon />
                                        </div>
                                        <TextField
                                          required
                                          className="w-100"
                                          label="Username/Mobile Number"
                                          name="username"
                                          // type="email"
                                          variant="standard"
                                          size="small"
                                          value={formik.values.username}
                                          onChange={(e) => {
                                            setType(e.target.value);
                                            formik.handleChange(e);
                                          }}
                                          error={
                                            formik.touched.username &&
                                            Boolean(formik.errors.username)
                                          }
                                          helperText={
                                            formik.touched.username &&
                                            formik.errors.username
                                          }
                                          onInput={(e) => {
                                            e.target.value = e.target.value
                                              .toString()
                                              .slice(0, 11);
                                          }}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                                <div class="input-group input-group-outline input_field mt-4">
                                  {isNaN(formik.values.username) && (
                                    <div class="col-md-12 d-inline-flex">
                                      <div className="me-2 mt-3">
                                        <LockIcon />
                                      </div>
                                      <div class="input-group input-group-outline input_field">
                                        <TextField
                                          required
                                          className="w-100"
                                          label="Password"
                                          name="password"
                                          type={
                                            showPassword ? "text" : "password"
                                          }
                                          variant="standard"
                                          size="small"
                                          value={formik.values.password}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.password &&
                                            Boolean(formik.errors.password)
                                          }
                                          helperText={
                                            formik.touched.password &&
                                            formik.errors.password
                                          }
                                          InputProps={{
                                            // <-- This is where the toggle button is added.
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  aria-label="toggle password visibility"
                                                  onClick={
                                                    handleClickShowPassword
                                                  }
                                                  onMouseDown={
                                                    handleMouseDownPassword
                                                  }
                                                >
                                                  {showPassword ? (
                                                    <VisibilityIcon
                                                      sx={{ color: "#85CBF2" }}
                                                    />
                                                  ) : (
                                                    <VisibilityOffIcon
                                                      sx={{ color: "#85CBF2" }}
                                                    />
                                                  )}
                                                </IconButton>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {isNaN(formik.values.username) && (
                                <button
                                  class="btn bg-gradient-primary register_grad d-block w-100 m"
                                  type="submit"
                                >
                                  Log in
                                </button>
                              )}

                              {!isNaN(formik.values.username) && (
                                <div className="text-end">
                                  <button
                                    className="btn bg-gradient-primary register_grad d-block w-100 m"
                                    type="button"
                                    disabled={
                                      formik.errors.username ||
                                      formik.values.username == ""
                                    }
                                    onClick={sendOtp}
                                  >
                                    Send OTP
                                  </button>
                                </div>
                              )}
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <Link
                                  to="/forgotpassword"
                                  class="text-capitalize link-info fw-bold"
                                >
                                  Forgot Password
                                </Link>
                              </div>

                              <div className="col-md-6">
                                <div className="text-end">
                                  <a
                                    href="#"
                                    onClick={formik.handleReset}
                                    class="text-capitalize link-info fw-bold"
                                  >
                                    Reset
                                  </a>
                                </div>
                              </div>
                            </div>

                            {/* <div className="row">
                          <div className="col-md-12">
                            <div class="text-center mt-4">
                              Don't have an account?
                              <Link
                                to="/SignUp"
                                class="text-capitalize  link-info fw-bold"
                              >
                                {" "}
                                Sign Up
                              </Link>
                            </div>
                          </div>
                        </div> */}
                          </form>
                        )}

                        {isOpenOtp && (
                          <form
                            class="form_hire p-0"
                            onSubmit={formik1.handleSubmit}
                          >
                            <div class="" id="sign_in">
                              <div class="">
                                <div class="text-center">
                                  <LockOpenIcon />
                                </div>
                                <div class="text-center mt-2">
                                  <span class="d-inline-block text-capitalize">
                                    sign in
                                  </span>
                                </div>
                              </div>
                              <div class="my-4">
                                <div class="input-group input-group-outline input_field">
                                  <div class="col-md-12 d-inline-flex">
                                    <div className="me-2 mt-3">
                                      <KeyIcon />
                                    </div>
                                    <TextField
                                      required
                                      className="w-100"
                                      label="Enter OTP"
                                      name="otp"
                                      // type="email"
                                      variant="standard"
                                      size="small"
                                      autoFocus
                                      value={formik1.values.otp}
                                      onChange={(e) => {
                                        setType(e.target.value);
                                        formik1.handleChange(e);
                                      }}
                                      error={
                                        formik1.touched.otp &&
                                        Boolean(formik1.errors.otp)
                                      }
                                      helperText={
                                        formik1.touched.otp &&
                                        formik1.errors.otp
                                      }
                                      onInput={(e) => {
                                        e.target.value = Math.max(
                                          0,
                                          parseInt(e.target.value)
                                        )
                                          .toString()
                                          .slice(0, 4);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              <button
                                class="btn bg-gradient-primary register_grad d-block w-100 m"
                                type="submit"
                              >
                                Verify OTP & Login
                              </button>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                <Link
                                  to="/SignUp"
                                  class="text-capitalize  link-info fw-bold"
                                  onClick={resetSTATE}
                                >
                                  {" "}
                                  Sign Up
                                </Link>
                              </div>

                              <div className="col-md-6">
                                <div className="text-end">
                                  <a
                                    href="#"
                                    onClick={formik1.handleReset}
                                    class="text-capitalize link-info fw-bold"
                                  >
                                    Reset
                                  </a>
                                </div>
                              </div>
                            </div>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="d-md-none d-flex bg_18 h_vh px_15 py-5">
                    <div class="w-100 my-auto">
                      <div class="ps_8 my-auto py_5">
                        <img src={fireLogo} class="img-fluid d-block mx-auto" />
                        <p class="text-center m-0 my-4 fw-bold">
                          FIREBIRD, An Omni Channel Solution which broadens
                          Communication channels to Telecom operators. Its an
                          integrated platform to meet the Business requirements
                          with respect to Messaging solutions and Voice
                          solutions.
                        </p>
                        <div
                          class="d-flex justify-content-center align-items-center fw-bold"
                          style={{ color: "#000" }}
                        >
                          {/* <Link to="/contactus"> */}
                          <Button
                            variant="contained"
                            endIcon={<ContactEmergencyIcon />}
                            onClick={() => {
                              contactModal();
                            }}
                          >
                            Contact US
                          </Button>
                          {/* </Link> */}
                          {/* <ConnectWithoutContactIcon
                          style={{ cursor: "pointer", fontSize: "28px" }}
                          className="d-block ms-3"
                        /> */}
                        </div>
                      </div>
                      <div class="bg_8 p-4">
                        {!isOpenOtp && (
                          <form
                            class="form_hire p-0"
                            onSubmit={formik.handleSubmit}
                          >
                            <div class="" id="sign_in_1">
                              <div class="">
                                <div class="text-center">
                                  <LockOpenIcon />
                                </div>
                                <div class="text-center mt-2">
                                  <span class="d-inline-block text-capitalize">
                                    sign in
                                  </span>
                                </div>
                              </div>
                              <div class="my-4">
                                <div class="d-flex">
                                  {/* <div className="d-flex"> */}
                                  <div className="me-2 mt-3">
                                    <PersonIcon />
                                  </div>
                                  <TextField
                                    required
                                    className="w-100"
                                    label="Username/Mobile Number"
                                    name="username"
                                    // type="email"
                                    variant="standard"
                                    size="small"
                                    autoFocus
                                    value={formik.values.username}
                                    onChange={(e) => {
                                      setType(e.target.value);
                                      formik.handleChange(e);
                                    }}
                                    error={
                                      formik.touched.username &&
                                      Boolean(formik.errors.username)
                                    }
                                    helperText={
                                      formik.touched.username &&
                                      formik.errors.username
                                    }
                                  />
                                  {/* </div> */}
                                </div>
                                <div class="input-group input-group-outline input_field mt-4">
                                  {isNaN(formik.values.username) && (
                                    <div class="d-flex w-100">
                                      <div className="me-2 mt-3">
                                        <LockIcon />
                                      </div>
                                      <div class="input-group input-group-outline input_field">
                                        <TextField
                                          required
                                          className="w-100"
                                          label="Password"
                                          name="password"
                                          type={
                                            showPassword ? "text" : "password"
                                          }
                                          variant="standard"
                                          size="small"
                                          value={formik.values.password}
                                          onChange={formik.handleChange}
                                          error={
                                            formik.touched.password &&
                                            Boolean(formik.errors.password)
                                          }
                                          helperText={
                                            formik.touched.password &&
                                            formik.errors.password
                                          }
                                          InputProps={{
                                            // <-- This is where the toggle button is added.
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  aria-label="toggle password visibility"
                                                  onClick={
                                                    handleClickShowPassword
                                                  }
                                                  onMouseDown={
                                                    handleMouseDownPassword
                                                  }
                                                >
                                                  {showPassword ? (
                                                    <VisibilityIcon
                                                      sx={{ color: "#85CBF2" }}
                                                    />
                                                  ) : (
                                                    <VisibilityOffIcon
                                                      sx={{ color: "#85CBF2" }}
                                                    />
                                                  )}
                                                </IconButton>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              {isNaN(formik.values.username) && (
                                <button
                                  class="btn bg-gradient-primary register_grad d-block w-100 m"
                                  type="submit"
                                >
                                  Log in
                                </button>
                              )}

                              {!isNaN(formik.values.username) && (
                                <div className="text-end">
                                  <button
                                    className="btn bg-gradient-primary register_grad d-block w-100 m"
                                    type="button"
                                    disabled={
                                      formik.errors.username ||
                                      formik.values.username == ""
                                    }
                                    onClick={sendOtp}
                                  >
                                    Send OTP
                                  </button>
                                </div>
                              )}
                            </div>
                            <div className="d-flex justify-content-between">
                              {/* <div className="col-md-6"> */}
                              <Link
                                to="/forgotpassword"
                                class="text-capitalize link-info fw-bold"
                              >
                                Forgot Password
                              </Link>
                              {/* </div> */}

                              {/* <div className="col-md-6"> */}
                              {/* <div className="text-end"> */}
                              <a
                                href="#"
                                onClick={formik.handleReset}
                                class="text-capitalize link-info fw-bold"
                              >
                                Reset
                              </a>
                              {/* </div> */}
                              {/* </div> */}
                            </div>

                            {/* <div className="row">
                          <div className="col-md-12">
                            <div class="text-center mt-4">
                              Don't have an account?
                              <Link
                                to="/Signup"
                                class="text-capitalize  link-info fw-bold"
                              >
                                {" "}
                                Sign Up
                              </Link>
                            </div>
                          </div>
                        </div> */}
                          </form>
                        )}

                        {isOpenOtp && (
                          <form
                            class="form_hire p-0"
                            onSubmit={formik1.handleSubmit}
                          >
                            <div class="" id="sign_in_1">
                              <div class="">
                                <div class="text-center">
                                  <LockOpenIcon />
                                </div>
                                <div class="text-center mt-2">
                                  <span class="d-inline-block text-capitalize">
                                    Enter OTP
                                  </span>
                                </div>
                              </div>
                              <div class="my-4">
                                <div class="d-flex">
                                  {/* <div className="d-flex"> */}
                                  <div className="me-2 mt-3">
                                    <KeyIcon />
                                  </div>
                                  <TextField
                                    required
                                    className="w-100"
                                    label="Enter OTP"
                                    name="otp"
                                    // type="email"
                                    variant="standard"
                                    size="small"
                                    autoFocus
                                    value={formik1.values.otp}
                                    onChange={(e) => {
                                      setType(e.target.value);
                                      formik1.handleChange(e);
                                    }}
                                    error={
                                      formik1.touched.otp &&
                                      Boolean(formik1.errors.otp)
                                    }
                                    helperText={
                                      formik1.touched.otp && formik1.errors.otp
                                    }
                                  />
                                  {/* </div> */}
                                </div>
                              </div>

                              <button
                                class="btn bg-gradient-primary register_grad d-block w-100 m"
                                type="submit"
                              >
                                Verify OTP & Login
                              </button>
                            </div>
                            <div className="d-flex justify-content-between">
                              {/* <div className="col-md-6"> */}
                              <Link
                                to="/forgotpassword"
                                class="text-capitalize link-info fw-bold"
                              >
                                Forgot Password
                              </Link>
                              {/* </div> */}

                              {/* <div className="col-md-6"> */}
                              {/* <div className="text-end"> */}
                              <a
                                href="#"
                                onClick={formik.handleReset}
                                class="text-capitalize link-info fw-bold"
                              >
                                Reset
                              </a>
                              {/* </div> */}
                              {/* </div> */}
                            </div>

                            {/* <div className="row">
                          <div className="col-md-12">
                            <div class="text-center mt-4">
                              Don't have an account?
                              <Link
                                to="/Signup"
                                class="text-capitalize  link-info fw-bold"
                              >
                                {" "}
                                Sign Up
                              </Link>
                            </div>
                          </div>
                        </div> */}
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                  <LoginLoader visible={props.loading} />
                </div>
              </>
            ) : (
              <>
                {/* ......................................Two Factor Auth........................................................ */}

                <div class="container-fluid px-0">
                  <div class="row d-md-flex d-none h_vh align-items-cente mx-0">
                    <div class="col-md-7 bg_18 d-flex">
                      <div class="ps_8 my-auto py_5">
                        <img src={fireLogo} class="img-fluid d-block mx-auto" />
                        {/* <img src={fireLogo} class="img-fluid d-block mx-auto" /> */}

                        <p class="text-center m-0 my-4 fw-bold">
                          Moov Mauritel, An Omni Channel Solution which broadens
                          Communication channels to Telecom operators. Its an
                          integrated platform to meet the Business requirements
                          with respect to Messaging solutions and Voice
                          solutions.
                        </p>
                        <div
                          class="d-flex justify-content-center align-items-center fw-bold"
                          style={{ color: "#000" }}
                        >
                          {/* <Link to="/contactus"> */}
                          <Button
                            variant="contained"
                            endIcon={<ContactEmergencyIcon />}
                            onClick={() => {
                              contactModal();
                            }}
                          >
                            Contact US
                          </Button>
                        </div>
                      </div>
                    </div>

                    {otpVerify == undefined && googleAuth != undefined ? (
                      <>
                        {/* <div>
                          <img src={googleAuth} alt="Loading.." />
                        </div> */}
                        <div class="col-md-5 my-auto">
                          <form class="form_hire p-0" onSubmit={VerifyOtp}>
                            <div class="" id="sign_in">
                              <div class="">
                                <div class="d-flex text-center">
                                  {/* <DoneIcon
                                      style={{
                                        fontSize: "25px",
                                        color: "white",
                                        border: "0.5px solid #0083AD",
                                        borderRadius: "30px",
                                        backgroundColor: "#0083AD",
                                      }}
                                    /> */}
                                  <div class="mx-auto position-relative">
                                    <ShieldIcon
                                      style={{
                                        fontSize: "2.6rem",
                                        color: "rgb(0, 131, 173)",
                                      }}
                                    />
                                    <div
                                      className="d-flex position-absolute"
                                      style={{
                                        top: "0",
                                        bottom: "0",
                                        left: "0",
                                        right: "0",
                                      }}
                                    >
                                      <CheckIcon
                                        className="m-auto text-white"
                                        style={{ fontSize: "1.9rem" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="text-center mt-4">
                                  <span class="" style={{ fontWeight: "500" }}>
                                    {/* Two-Factor Authentication */}
                                    Verification Code
                                  </span>
                                  <p class="my-4">
                                    <span style={{ fontWeight: "500" }}>
                                      Welcome,
                                    </span>{" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {localStorage.getItem("Username")}
                                    </span>
                                  </p>
                                  {/* <p style={{ fontWeight: "500" }}>
                                    {selectedValue == "Mobile Number" ? (
                                      <>
                                        Otp has been sent to your registered
                                        mobile
                                        <br></br>
                                        number{" "}
                                        {JSON.parse(
                                          localStorage.getItem("items")
                                        )?.mobile.replace(/\d(?=\d{4})/g, "X")}
                                      </>
                                    ) : (
                                      <>
                                        Otp has been sent to your registered
                                        email
                                        <br></br>
                                        {maskedEmail}
                                      </>
                                    )}
                                  </p> */}
                                </div>
                              </div>

                              <button
                                 
                                    type="button"
                                    className="btn w_btn m-0 btn_w8 btn_design2"
                                    style={{
                                      backgroundImage:
                                        " linear-gradient(195deg,#004872,#008cb6)",
                                      fontSize: "14px",
                                    }}
                                    onClick={ScanUserModal}
                                  >
                                    Click to scan QR Code
                                    {/* <SettingsBackupRestoreRoundedIcon
                          style={{ fontSize: "17px" }}
                        />{" "} */}
                                  </button>

 <button
                                    type="button"
                                    className="btn bg-gradient-secondary m-0 w_btn btn_w8 btnReset btn_design1"
                                    onClick={() => {
                                      setOtpVerify();
                                      localStorage.removeItem("transactionId");
                                      localStorage.removeItem("googleAuth");
                                      setgoogleAuth();
                                      setPart1("");
                                      setPart2("");
                                      setPart3("");
                                      setPart4("");
                                      setPart5("");
                                      setPart6("");
                                    }}
                                  >
                                    Back
                                  
                                  </button>
                           
                            </div>
                          </form>
                        </div>
                      </>
                    ) : otpVerify == undefined ? (
                      <>
                        {" "}
                        <div
                          class="col-md-5 d-flex align-items-center bg_8 "
                          style={{ padding: "3.5rem" }}
                        >
                          <div class="w-100">
                            <form
                              class="form_hire p-0"
                              onSubmit={MobileNumberGenerator}
                            >
                              <div class="" id="sign_in">
                                <div class="">
                                  <div class="d-flex text-center">
                                    {/* <DoneIcon
  style={{
    fontSize: "25px",
    color: "white",
    border: "0.5px solid #0083AD",
    borderRadius: "30px",
    backgroundColor: "#0083AD",
  }}
/> */}
                                    <div class="mx-auto position-relative">
                                      <ShieldIcon
                                        style={{
                                          fontSize: "2.6rem",
                                          color: "rgb(0, 131, 173)",
                                        }}
                                      />
                                      <div
                                        className="d-flex position-absolute"
                                        style={{
                                          top: "0",
                                          bottom: "0",
                                          left: "0",
                                          right: "0",
                                        }}
                                      >
                                        <LockOutlinedIcon
                                          className="m-auto text-white"
                                          style={{ fontSize: "1.3rem" }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="text-center mt-2">
                                    <span
                                      class=""
                                      style={{ fontWeight: "500" }}
                                    >
                                      {/* Two-Factor Authentication */}2 Step
                                      Authentication
                                    </span>
                                  </div>
                                </div>

                                <div class="my-4">
                                  <div class="input-group input-group-outline input_field">
                                    {JSON.parse(localStorage.getItem("items"))
                                      ?.mobile != null &&
                                    JSON.parse(localStorage.getItem("items"))
                                      ?.email != null ? (
                                      <>
                                        {" "}
                                        <FormGroup>
                                          <div className="d-flex">
                                            <FormControlLabel
                                              className="fontStyle"
                                              control={
                                                <Checkbox
                                                  checked={
                                                    selectedValue ===
                                                    "Mobile Number"
                                                  }
                                                  onChange={handleChange2fa}
                                                  value="Mobile Number"
                                                />
                                              }
                                              label="via SMS"
                                            />
                                            <p style={{ marginTop: "0.85rem" }}>
                                              (
                                              {JSON.parse(
                                                localStorage.getItem("items")
                                              )?.mobile.replace(
                                                /\d(?=\d{4})/g,
                                                "X"
                                              )}
                                              )
                                            </p>
                                          </div>

                                          <div className="d-flex">
                                            <FormControlLabel
                                              className="fontStyle"
                                              control={
                                                <Checkbox
                                                  checked={
                                                    selectedValue === "Email"
                                                  }
                                                  onChange={handleChange2fa}
                                                  value="Email"
                                                />
                                              }
                                              label="via Email"
                                            />
                                            {/* <p style={{marginTop: "0.85rem"}}>({JSON.parse(localStorage.getItem("items")) ?.email.replace(/.(?=.{10})/g, '*')}) </p>
                                             */}
                                            <p style={{ marginTop: "0.85rem" }}>
                                              ({maskedEmail}){" "}
                                            </p>
                                          </div>

                                          {/* <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={
                                                  selectedValue ===
                                                  "Google Authneticator"
                                                }
                                                onChange={handleChange2fa}
                                                value="Google Authneticator"
                                              />
                                            }
                                            label="via Google Authneticator"
                                          /> */}
                                        </FormGroup>
                                      </>
                                    ) : JSON.parse(
                                        localStorage.getItem("items")
                                      )?.mobile != null ? (
                                      <>
                                        <FormGroup>
                                          <FormControlLabel
                                            className="fontStyle"
                                            control={
                                              <Checkbox
                                                checked={
                                                  selectedValue ===
                                                  "Mobile Number"
                                                }
                                                onChange={handleChange2fa}
                                                value="Mobile Number"
                                              />
                                            }
                                            label="via SMS"
                                          />
                                          <p style={{ marginTop: "0.85rem" }}>
                                            (
                                            {JSON.parse(
                                              localStorage.getItem("items")
                                            )?.mobile.replace(
                                              /\d(?=\d{4})/g,
                                              "X"
                                            )}
                                            )
                                          </p>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={
                                                  selectedValue ===
                                                  "Google Authneticator"
                                                }
                                                onChange={handleChange2fa}
                                                value="Google Authneticator"
                                              />
                                            }
                                            label="via Google Authneticator"
                                          />
                                        </FormGroup>
                                      </>
                                    ) : (
                                      <>
                                        <FormGroup>
                                          <FormControlLabel
                                            className="fontStyle"
                                            control={
                                              <Checkbox
                                                checked={
                                                  selectedValue === "Email"
                                                }
                                                onChange={handleChange2fa}
                                                value="Email"
                                              />
                                            }
                                            label="via Email"
                                          />
                                          {/* <p style={{marginTop: "0.85rem"}}>({JSON.parse(localStorage.getItem("items")) ?.email.replace(/\d(?=\d{4})/g, "X")})</p> */}
                                          <p style={{ marginTop: "0.85rem" }}>
                                            ({maskedEmail}){" "}
                                          </p>

                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={
                                                  selectedValue ===
                                                  "Google Authneticator"
                                                }
                                                onChange={handleChange2fa}
                                                value="Google Authneticator"
                                              />
                                            }
                                            label="via Google Authneticator"
                                          />
                                        </FormGroup>
                                      </>
                                    )}

                                    {/* <div>
    {options.map((option) => {
      return(
        <div>

      <FormControlLabel
        key={option.value}
        control={
          <Checkbox
            checked={selectedOption === option.value}
            onChange={handleChange2fa}
            value={option.value}
          />
        }
        label={option.label}
      />

      <p>
       ({option.Number .replace(/\d(?=\d{4})/g, "X")})
      </p>
      </div>
    )})}
  </div> */}
                                  </div>
                                  <div className="col-md-10 d-flex justify-content-between mt-4">
                                    <button
                                      type="button"
                                      className="btn bg-gradient-secondary m-0 w_btn btn_w8 btnReset btn_design1"
                                      onClick={backButton}
                                    >
                                      Back
                                      {/* <SettingsBackupRestoreRoundedIcon
                          style={{ fontSize: "17px" }}
                        />{" "} */}
                                    </button>

                                    <button
                                      disabled={selectedValue == ""}
                                      type="submit"
                                      className="btn w_btn m-0 btn_w8 btn_design2"
                                      style={{
                                        backgroundImage:
                                          " linear-gradient(195deg,#004872,#008cb6)",
                                        fontSize: "14px",
                                      }}
                                      // onClick={MobileNumberGenerator}
                                    >
                                      Send Request
                                      {/* <AddRoundedIcon style={{ fontSize: "19px" }} /> */}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div class="col-md-5 my-auto">
                          <form class="form_hire p-0" onSubmit={VerifyOtp}>
                            <div class="" id="sign_in">
                              <div class="">
                                <div class="d-flex text-center">
                                  {/* <DoneIcon
                                      style={{
                                        fontSize: "25px",
                                        color: "white",
                                        border: "0.5px solid #0083AD",
                                        borderRadius: "30px",
                                        backgroundColor: "#0083AD",
                                      }}
                                    /> */}
                                  <div class="mx-auto position-relative">
                                    <ShieldIcon
                                      style={{
                                        fontSize: "2.6rem",
                                        color: "rgb(0, 131, 173)",
                                      }}
                                    />
                                    <div
                                      className="d-flex position-absolute"
                                      style={{
                                        top: "0",
                                        bottom: "0",
                                        left: "0",
                                        right: "0",
                                      }}
                                    >
                                      <CheckIcon
                                        className="m-auto text-white"
                                        style={{ fontSize: "1.9rem" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="text-center mt-4">
                                  <span class="" style={{ fontWeight: "500" }}>
                                    {/* Two-Factor Authentication */}
                                    Verification Code
                                  </span>
                                  <p class="my-4">
                                    <span style={{ fontWeight: "500" }}>
                                      Welcome,
                                    </span>{" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {localStorage.getItem("Username")}
                                    </span>
                                  </p>
                                  <p style={{ fontWeight: "500" }}>
                                    {selectedValue == "Mobile Number" ? (
                                      <>
                                        Otp has been sent to your registered
                                        mobile
                                        <br></br>
                                        number{" "}
                                        {JSON.parse(
                                          localStorage.getItem("items")
                                        )?.mobile.replace(/\d(?=\d{4})/g, "X")}
                                      </>
                                    ) : (
                                      <>
                                        Otp has been sent to your registered
                                        email
                                        <br></br>
                                        {maskedEmail}
                                      </>
                                    )}
                                  </p>
                                </div>
                              </div>

                              <div class="my-4">
                                <div
                                  class="input-group input-group-outline input_field mx-auto"
                                  style={{ width: "60%", background: "none" }}
                                >
                                  {/* <TextField
                                required
                                className="w-20"
                                label="Verify Otp"
                                name="otp"
                                // type="email"
                                variant="standard"
                                size="small"
                                autoFocus
                                value={otpOnchange}
                                  onChange={(event) => {
                                    setOtpOnChange(event.target.value);
                                  }}
                              /> */}
                                  <div className="row alignDivnew">
                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part1"
                                        className="impMargin1 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        ref={inputRef1}
                                        value={part1}
                                        onChange={(event) =>
                                          handleInputChange(event, setPart1)
                                        }
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart1("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part2"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part2}
                                        ref={inputRef2}
                                        onChange={(event) =>
                                          handleInputChange2(event, setPart2)
                                        }
                                        onKeyDown={handleKeyDown2}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart2("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part3"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part3}
                                        ref={inputRef3}
                                        onChange={(event) =>
                                          handleInputChange3(event, setPart3)
                                        }
                                        onKeyDown={handleKeyDown3}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart3("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part4"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part4}
                                        ref={inputRef4}
                                        onChange={(event) =>
                                          handleInputChange4(event, setPart4)
                                        }
                                        onKeyDown={handleKeyDown4}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart4("");
                                          }
                                        }}
                                      />
                                    </div>

                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part4"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part5}
                                        ref={inputRef5}
                                        onChange={(event) =>
                                          handleInputChange5(event, setPart5)
                                        }
                                        onKeyDown={handleKeyDown5}
                                        onKeyPress={(event) => {
                                          const keyCode =
                                            event.keyCode || event.which;

                                          if (keyCode >= 48 && keyCode <= 57) {
                                            setPart5("");
                                          }
                                        }}
                                      />
                                    </div>
                                    <div className="col d-flex align-items-center">
                                      <input
                                        // type="number"
                                        id="part4"
                                        className="impMargin2 otp_Input"
                                        required
                                        // min={0}
                                        // max={9}
                                        maxLength={1}
                                        value={part6}
                                        ref={inputRef6}
                                        onChange={(event) =>
                                          handleInputChange6(event, setPart6)
                                        }
                                        onKeyDown={handleKeyDown6}
                                      />
                                    </div>
                                    {/* <div class="row">
                                    <button
                          style={{ marginLeft: "6px" }}
                          type="button"
                        onClick={()=>{
                          setPart1("*")
                          setPart2("*")
                          setPart3("*")
                          setPart4("*")
                        
                        }}
                          className="btn bg-gradient-secondary "
                        >
                          Reset
                          <i className="material-icons opacity-10">
                            settings_backup_restore
                          </i>
                        </button>
                                    </div> */}
                                  </div>
                                </div>
                                <div className="counterDiv">
                                  {/* <AccessTimeIcon   /> */}

                                  {/* {!resend && <AccessTimeIcon />} */}
                                  <OtpTimer
                                    id="btn_reset"
                                    className="mt-2"
                                    minutes={4}
                                    seconds={59}
                                    text=" "
                                    ButtonText="Resend Otp"
                                    resend={MobileNumberGenerator}
                                  />
                                  {/* <button 
                                      onClick={MobileNumberGenerator}>Resend</button> */}

                                  {/* </OtpTimer> */}
                                  {/* <OtpTimer
  minutes={0}
  seconds={6}
  resend={MobileNumberGenerator}
>
  {(minutes, seconds) =>
    minutes === 0 && seconds === 0 ? null : <button onClick={MobileNumberGenerator}>Resend</button>
  }
</OtpTimer> */}
                                </div>
                                {/* <div className="" style={{width:"84%", textAlign: "right"}}>
                                  <button  className="btn w_btn m-0 btn_w8 btn_design2" style={{ backgroundImage: " linear-gradient(195deg,#004872,#008cb6)", fontSize: "11px" }} onClick={MobileNumberGenerator}>
                                      resend
                                    </button>   
                                    </div> */}
                                <div className="col-md-8 mx-auto mt-5 d-flex justify-content-between">
                                  <button
                                    type="button"
                                    className="btn bg-gradient-secondary m-0 w_btn btn_w8 btnReset btn_design1"
                                    onClick={() => {
                                      setOtpVerify();
                                      localStorage.removeItem("transactionId");
                                      setPart1("");
                                      setPart2("");
                                      setPart3("");
                                      setPart4("");
                                      setPart5("");
                                      setPart6("");
                                    }}
                                  >
                                    Back
                                    {/* <SettingsBackupRestoreRoundedIcon
                          style={{ fontSize: "17px" }}
                        />{" "} */}
                                  </button>
                                  <button
                                    disabled={
                                      part1 === "" ||
                                      part2 === "" ||
                                      part3 === "" ||
                                      part4 === ""
                                    }
                                    type="submit"
                                    className="btn w_btn m-0 btn_w8 btn_design2"
                                    style={{
                                      backgroundImage:
                                        " linear-gradient(195deg,#004872,#008cb6)",
                                      fontSize: "14px",
                                    }}
                                    // onClick={VerifyOtp}
                                  >
                                    Confirm Otp
                                    {/* <SettingsBackupRestoreRoundedIcon
                          style={{ fontSize: "17px" }}
                        />{" "} */}
                                  </button>
                                </div>
                                <div></div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </>
                    )}
                  </div>

                  <LoginLoader visible={props.loading} />
                </div>
              </>
            )}

            {/* ...............................................2 Factor Auth.............................................................. */}
          </main>
        </ThemeProvider>
      </body>
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.authReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
  loginNumber: (otp) => dispatch(loginNumber(otp)),
  login: (username, password, accountType) =>
    dispatch(login(username, password, accountType)),
  twoFactorAuthentication: () => dispatch(twoFactorAuthentication()),
  logout: () => dispatch(logout(localStorage.getItem("Username"))),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginInTheHouse);
